import { Auth, User } from "firebase/auth";
import { auth } from "~/lib/firebase";

/**
 * Mock User object for testing
 */
export interface MockUser extends Partial<User> {
  uid: string;
  email?: string | null;
  displayName?: string | null;
}

/**
 * Creates a mock auth object with a mock user
 */
const createMockAuth = (mockUser: MockUser): Auth => {
  return {
    currentUser: mockUser as User,
  } as Auth;
};

/**
 * Wrapper for auth that can return either the real Firebase auth
 * or a mock auth object based on environment configuration.
 *
 * @param mockUser - Optional mock user to use when in test/staging mode
 * @returns Auth object (real or mock)
 */
export const getAuthWrapper = (mockUser?: MockUser): Auth => {
  const isTestMode = process.env.REACT_APP_TESTING_MODE === "true";

  if (isTestMode) {
    const testTenantId = process.env.REACT_APP_TESTING_OWNER_ID;
    const testTenantEmail = process.env.REACT_APP_TESTING_OWNER_EMAIL;

    const user: MockUser = mockUser || {
      uid: testTenantId || "test-tenant-id",
      email: testTenantEmail || "test@example.com",
    };

    return createMockAuth(user);
  }

  return auth;
};
